// extracted by mini-css-extract-plugin
export default {"link":"pE-z","disabled":"qE-z"};